var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9209 11.2041L23.0459 3.32906C22.9414 3.22462 22.8173 3.14181 22.6807 3.08535C22.5441 3.02889 22.3978 2.99988 22.25 3H8.75C8.15326 3 7.58097 3.23705 7.15901 3.65901C6.73705 4.08097 6.5 4.65326 6.5 5.25V30C6.5 30.5967 6.73705 31.169 7.15901 31.591C7.58097 32.0129 8.15326 32.25 8.75 32.25H29C29.5967 32.25 30.169 32.0129 30.591 31.591C31.0129 31.169 31.25 30.5967 31.25 30V12C31.2501 11.8522 31.2211 11.7059 31.1647 11.5693C31.1082 11.4327 31.0254 11.3086 30.9209 11.2041ZM23.375 6.84047L27.4095 10.875H23.375V6.84047ZM29 30H8.75V5.25H21.125V12C21.125 12.2984 21.2435 12.5845 21.4545 12.7955C21.6655 13.0065 21.9516 13.125 22.25 13.125H29V30Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.734b66bb4a06367b1f933635b73bedbd.svg";
export { ForwardRef as ReactComponent };